import React, { Component } from 'react'
import CustomHeader from '../components/Header'
import CustomFooter from '../components/Footer'
import VehicleGroupCard from '../components/VehicleGroupCard';
import auth from '../auth'
import axiosConfig from '../config/axiosConfig';
import ViewSuspTransHome from '../containers/comps/ViewSuspTransHomeContainer'
import { Card, Row, Col, Accordion } from 'react-bootstrap';
import BoxItemDropDown from '../components/BoxItemDropDown'
import AccordionItemsUserBranches from '../components/AccordionItemsUserBranches'



// function RenderUserBranchesSection(BranchData) {
//     //console.log("BranchData:",BranchData)
//     return (


//         <Row>
//             <Col>
//                 <Accordion>
//                     <Card className="card p-3 text-center" style={{ width: '100%', margin: 'auto', boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
//                         <Card.Title>Choose an Account</Card.Title>
//                         <Card.Body>
//                             {BranchData && <Child items={BranchData.AccountsData} />}
//                             {/* <div>1</div> */}
//                         </Card.Body>
//                     </Card>
//                 </Accordion>
//             </Col>
//         </Row>
//     );
// }


// function Child({ items }) {
//     console.log("Items", items)
//     return (
//         items.map((el, index) => {
//             return (
//                 //  {console.log("el = ", el)}
//                 <div className="box-item btn btn-default w-100">
//                     <AccordionItemsUserBranches index={index} name={el.shellAccountNumber} accordionSubItems={el._BranchDetail} ></AccordionItemsUserBranches>
//                 </div>
//                 // <div>{index}</div>
//             )
//         })
//         // <div>1</div>
//     );
// }



class ViewSuspTransSummary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: '',
            accounts: [],
            selectedBranchID: localStorage.getItem('selectedBranch'),
            isBranchSelected: localStorage.getItem('isBranchSelected'),
            UserId: localStorage.getItem('userid')
        };
    }

    getBranches() {
        axiosConfig.post('Portal/UserBranches', {
            "UserId": this.state.UserId
        })
            .then((res) => {
            })
            .catch(console.error)
            .finally(() => {
            });
    }

    cb_setBranch = (childData) => {
        this.setState({isBranchSelected: childData})

    }

    componentDidMount() {
        axiosConfig.post('Portal/UserBranches', {
            "UserId": this.state.UserId
        })
            .then((res) => {
                this.setState({ accounts: res.data.accounts })

            })
            .catch(console.error)
            .finally(() => {
                console.log(this.state)

            });
    }

    render() {
        return (
                  <ViewSuspTransHome />
                  
                  );

    }
}


export default ViewSuspTransSummary;